<!--Overriding component with empty one is more consistent than a consuming app inherting css from Emperor-->
